import React from "react";
import classnames from "classnames";

interface Props {
	className?: string;
	children: React.ReactNode;
}

function ListGroup({ className, children }: Props) {
	return <ul className={classnames("list-group", className)}>{children}</ul>;
}

export default ListGroup;
